import { useRef } from 'react'
import { resolveImageDisplayWidth } from '@/components/app/TextEditor/imageResize'
import { useImageDisplay } from '@/components/app/TextEditor/useImageDisplay'
import css from '@/components/app/TextEditor/components/TextEditorImage/TextEditorImage.module.css'

// Read-only image node for the static viewer. Same markup/CSS as the editor's
// TextEditorImage, minus the Slate selection machinery and the resize handles — it honors a
// persisted `width` but can't change it. Load/width logic is shared via useImageDisplay so the
// two renderers stay in lockstep (CLAUDE.md editor↔read-view parity).
const StaticImage = ({ attributes, children, element }: any) => {
    const imgRef = useRef<HTMLImageElement>(null)
    const { dpr, imageReady, imageStateClass, handleLoad } = useImageDisplay(imgRef, element)

    const placeholderStyle = element.imgWidth && element.imgHeight
        ? {
            width: resolveImageDisplayWidth(element, dpr),
            height: 'auto' as const,
            aspectRatio: `${element.imgWidth}/${element.imgHeight}`,
        }
        : undefined

    return (
        <div {...attributes}>
            <div contentEditable={false} className={css.wrapper}>
                {!imageReady && (
                    <div className={css.loading_placeholder} style={placeholderStyle} />
                )}
                <img
                    ref={imgRef}
                    src={element.url}
                    alt=""
                    className={[css.image, imageStateClass].filter(Boolean).join(' ')}
                    draggable={false}
                    onLoad={handleLoad}
                />
            </div>
            {children}
        </div>
    )
}

export default StaticImage
